import { useEffect } from 'react';

const useIframeContentHeightMessage = (ref: React.RefObject<HTMLElement>) => {
  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    const postHeight = () => {
      window.parent.postMessage({ type: 'contentHeight', height: el.scrollHeight }, '*');
    };

    const observer = new ResizeObserver(postHeight);
    observer.observe(el);
    postHeight();

    return () => observer.disconnect();
  }, [ref]);
};

export default useIframeContentHeightMessage;
